import { TEmployeeRenewVisaDocumentStepGroup } from "@/api/entities/employee-renew-visa-document-step-group.entity";
import { useGetRenewVisaApplicationInformationGroupList } from "@/api/services/main/renew-visa";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { AfterSubmitApplicationStepCard } from "@/features/renew-visa/components/afterSubmitApplicationStep/AfterSubmitApplicationStepCard";
import { FC } from "react";

export type TRenewVisaAfterSubmitApplicationStepProps = {
  stepGroupData: TEmployeeRenewVisaDocumentStepGroup;
  readonly: boolean;
  isExistBasicInfoData: boolean;
};

export const RenewVisaAfterSubmitApplicationStep: FC<TRenewVisaAfterSubmitApplicationStepProps> = ({
  stepGroupData,
  readonly,
  isExistBasicInfoData,
}) => {
  const { id: renewVisaDocumentStepGroupId } = stepGroupData;
  const {
    data: applicationInformationGroupListData,
    isLoading,
    isFetching,
  } = useGetRenewVisaApplicationInformationGroupList({
    renewVisaDocumentStepGroupId,
  });

  if (isLoading || isFetching) return <LoadingArea />;

  return (
    <AfterSubmitApplicationStepCard
      isExistBasicInfoData={isExistBasicInfoData}
      readonly={readonly}
      applicationInformationGroupListData={applicationInformationGroupListData ?? []}
      stepGroupData={stepGroupData}
    />
  );
};
